import { CardConditionItemStyled } from '@/components/CardConditionItem/styled';
import CustomCard from '@/components/customCard';
import ConnectBadge from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/ConnectBadge';
import { BadgeProps } from '@shopify/polaris';
import { DeleteIcon } from '@shopify/polaris-icons';

interface IProps {
  title: React.ReactElement | string;
  onDismiss: () => void;
  children: React.ReactNode;
  hasConnectBadge?: boolean;
  badgeContent?: string;
  badgeTone?: BadgeProps['tone'];
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

const CartConditionItem = ({
  title,
  onDismiss,
  children,
  hasConnectBadge,
  badgeContent,
  badgeTone,
  collapsible,
  defaultExpanded,
}: IProps) => {
  return (
    <CardConditionItemStyled>
      {!!hasConnectBadge && <ConnectBadge tone={badgeTone}>{badgeContent || ''}</ConnectBadge>}
      <CustomCard
        title={title}
        textClassName="bold-text-styled"
        secondaryActions={{
          onAction: onDismiss,
          buttonProps: {
            icon: DeleteIcon,
            tone: 'critical',
            variant: 'plain',
          },
        }}
        hasDroplist
        collapsible={collapsible}
        defaultExpanded={defaultExpanded}
      >
        {children}
      </CustomCard>
    </CardConditionItemStyled>
  );
};

export default CartConditionItem;
